import { useContext } from 'react';

import { CompanyValidationContext } from '.';

export const useCompanyValidationStore = () => {
  return useContext(CompanyValidationContext);
};
